const EditableField = ({
  label,
  value,
  onChange,
  editMode,
  type = "text",
  placeholder,
  textarea = false,
}) => (
  <div>
    <label className="block text-xs text-text-muted uppercase tracking-wider mb-1.5">
      {label}
    </label>
    {editMode ? (
      textarea ? (
        <textarea
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          rows={8}
          className="w-full bg-bg-base border border-border rounded-xl px-4 py-2.5 text-sm text-text-primary placeholder-text-hint focus:outline-none focus:border-primary transition resize-none"
        />
      ) : (
        <input
          type={type}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full bg-bg-base border border-border rounded-xl px-4 py-2.5 text-sm text-text-primary placeholder-text-hint focus:outline-none focus:border-primary transition"
        />
      )
    ) : (
      <p className="text-sm text-text-primary py-2">
        {value || <span className="text-text-hint">—</span>}
      </p>
    )}
  </div>
);

export default EditableField;
